import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { IMechanicSchoolAdminBody } from '../../../../../core/models';
import { AdminService } from '../../../../../core/services/admin.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { SchoolAndTrainingService } from '../../../../../core/services/school-and-training.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { Transform } from 'stream';
import { environment } from '../../../../../../environments/environment';
@Component({
  selector: 'app-mechanics-school-admin',
  templateUrl: './mechanics-school-admin.component.html',
  styleUrls: ['./mechanics-school-admin.component.scss']
})
export class MechanicsSchoolAdminComponent implements OnInit {
  //#region member and variable declaration
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  locationInfoForm: FormGroup;
  locationFormValue: FormArray;
  todayDate: any = new Date();
  schoolDescription: string = "";
  registrationDescription: string = "";
 // generalInfoForm: FormGroup;
  getLanguages: any;
  selectedLanguage: string = "";
  mechanicsSchoolId: string = "";
  schoolDescriptionInputMethod: string = "TextEditor";
  schoolDescriptionPdfUrl = null;
  schoolDescriptionPdfUrlPath = null;
  registrationDescriptionInputMethod: string = "TextEditor";
  registrationDescriptionPdfUrl = null;
  registrationDescriptionPdfUrlPath = null;
  //#endregion
  constructor(private adminService: AdminService, private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService, private languageService: LanguageTranslationService,
    private trainingService: SchoolAndTrainingService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.initializeFormControl();
    //this.addNewLocation();
    this.languageService.getLanguages().subscribe(response => {
      this.getLanguages = response;
    })
    this.selectedLanguage = localStorage.getItem('language');
    this.lanaguageChange("");
  }
  //#region language dropdown change
  lanaguageChange(event) {
    const body = {
      languageCode: event ? event.languageCode : this.selectedLanguage
    }
    this.selectedLanguage = body.languageCode;
    this.mechanicsSchool.isLanguageCodeEmpty = false;
    this.trainingService.getMechanicsSchoolDetails(body).subscribe(response => {
      this.mechanicsSchoolId = "";
      this.resetForm('reset');
      if (response.length > 0) {
        this.mechanicsSchoolId = response[0].mechanicsSchoolId;
        this.locationInfoForm.controls.trainingName.setValue(response[0].trainingName);
        this.locationInfoForm.controls.trainingDescription.setValue(response[0].trainingDescription);
        this.schoolDescription=response[0].schoolDescription;
        this.registrationDescription = response[0].registrationDescription;
        if (response[0].mechanicsSchoolLocationDetails.length > 0) {
          response[0].mechanicsSchoolLocationDetails.forEach((attitem, index) => {
            this.locationFormValue = this.locationInfoForm.get('locationFormValue') as FormArray;
            this.locationFormValue.push(this.formBuilder.group({
              id: [attitem.id],
              locationId: [attitem.locationId],
              mechanicsSchoolId: [attitem.mechanicsSchoolId],
              locationName: [attitem.locationName],
              locationDescription: [attitem.locationDescription],
              price: [attitem.price],
              startDate: [new Date(attitem.startDate)],
              endDate: [new Date(attitem.endDate)],
              totalSeats: [attitem.totalSeats],
              place: [attitem.place],
              remainingSeats: [{ value: attitem.remainingSeats, disabled: true }],
            }));
          })
        } else {
          this.addNewLocation();
        }
        this.transformgMechanicsSchoolDetail(response[0])

      } else {
        this.addNewLocation();
      }
    })
  }
  transformgMechanicsSchoolDetail(mechanicsSchoolDetail: any) {
    
    if (mechanicsSchoolDetail) {
      if (mechanicsSchoolDetail.registrationDescriptionPdfUrlPath) {
        this.registrationDescriptionPdfUrlPath = mechanicsSchoolDetail.registrationDescriptionPdfUrlPath;
        this.registrationDescriptionPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.imageUrl + mechanicsSchoolDetail.registrationDescriptionPdfUrlPath);
        this.registrationDescriptionInputMethod = "FileUpload";
      } else {
        this.registrationDescriptionInputMethod = "TextEditor";
        this.registrationDescriptionPdfUrl = null;
      }
      if (mechanicsSchoolDetail.schoolDescriptionPdfUrlPath) {
        this.schoolDescriptionPdfUrlPath = mechanicsSchoolDetail.schoolDescriptionPdfUrlPath;
        this.schoolDescriptionPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl( environment.imageUrl + mechanicsSchoolDetail.schoolDescriptionPdfUrlPath);
        this.schoolDescriptionInputMethod = "FileUpload";

      } else {
        this.schoolDescriptionInputMethod = "TextEditor";
        this.schoolDescriptionPdfUrl = null;
      }
    }
  }
  //#endregion
  //#region label/variable declaration
  mechanicsSchool = {
    isGeneralInfoPanelValid: false,
    //isGeneralInfoPanelInValid: false,
    isLocationInfoPanelValid: false,
    //isLocationInfoPanelInValid: false,
    isRegistrtionPanelValid: false,
    isEmptySchoolDescription: false,
    isEmptyTrainingName: false,
    isEmptyTrainingDescription: false,
    isEmptyRegistrationDescription: false,
    isGeneralInfoContinue: false,
    isLocationInfoContinue: false,
    isSubmitted: false,
    isLanguageCodeEmpty: false,
    isEmptySchoolDescriptionUrlPath: false,
    isEmptyRegistrationDescriptionUrlPath: false
  }
  //#endregion
  //#region validation operations
  public validateGenralInfoForm() {
    let isValid = true;
    if (this.mechanicsSchool.isGeneralInfoContinue) {
      
      if (this.schoolDescriptionInputMethod === 'FileUpload') {
        if (this.schoolDescriptionPdfUrl) {
          this.mechanicsSchool.isEmptySchoolDescriptionUrlPath = false;
        } else {
          this.mechanicsSchool.isEmptySchoolDescriptionUrlPath = true;
          isValid = false;
        }
      } else {
        if (this.schoolDescription) {
          this.mechanicsSchool.isEmptySchoolDescription = false;
        } else {
          this.mechanicsSchool.isEmptySchoolDescription = true;
          isValid = false;
        }
      }
     
      if (this.selectedLanguage) {
        this.mechanicsSchool.isLanguageCodeEmpty = false;
      } else {
        this.mechanicsSchool.isLanguageCodeEmpty = true;
        isValid = false;
      }
    }
    return isValid;
  }
  public validateLocationInfoForm() {
    let isValid = true;
    if (this.mechanicsSchool.isLocationInfoContinue) {
      const controls = this.locationInfoForm.controls;
      if (controls.trainingName.value) {
        this.mechanicsSchool.isEmptyTrainingName = false;
      } else {
        this.mechanicsSchool.isEmptyTrainingName = true;
        isValid = false;
      }
      if (controls.trainingDescription.value) {
        this.mechanicsSchool.isEmptyTrainingDescription = false;
      } else {
        this.mechanicsSchool.isEmptyTrainingDescription = true;
        isValid = false;
      }
    }
    return isValid;
  }
  public validateRegistrationForm() {
    let isValid = true;
    if (this.mechanicsSchool.isSubmitted) {
      if (this.registrationDescriptionInputMethod === 'FileUpload') {
        if (this.registrationDescriptionPdfUrlPath) {
          this.mechanicsSchool.isEmptyRegistrationDescriptionUrlPath = false;
        } else {
          this.mechanicsSchool.isEmptyRegistrationDescriptionUrlPath = true;
          isValid = false;
        }
      } else {
        if (this.registrationDescription) {
          this.mechanicsSchool.isEmptyRegistrationDescription = false;
        } else {
          this.mechanicsSchool.isEmptyRegistrationDescription = true;
          isValid = false;
        }
      }
      
    }
    return isValid;
  }
  validateMechanicsSchoolPage() {
    var isValid = true;
    this.mechanicsSchool.isGeneralInfoContinue = true;
    this.mechanicsSchool.isGeneralInfoPanelValid = true;
   
    if (!this.validateGenralInfoForm()) {
      this.mechanicsSchool.isGeneralInfoPanelValid = false;
      isValid = false;
    }
    this.mechanicsSchool.isLocationInfoContinue = true;
    this.mechanicsSchool.isLocationInfoPanelValid = true;  
    
    if (!this.validateLocationInfoForm()) {
      this.mechanicsSchool.isLocationInfoPanelValid = false;
      isValid = false;
    }
    this.mechanicsSchool.isSubmitted = true;
    this.mechanicsSchool.isRegistrtionPanelValid = true;
    if (!this.validateRegistrationForm()) {
      this.mechanicsSchool.isRegistrtionPanelValid = false;
      isValid = false;
    }
    if (this.schoolDescriptionInputMethod === 'FileUpload') {
      if (!this.schoolDescriptionPdfUrlPath) {
        this.schoolDescriptionPdfUrlPath = null;
      }
    } else {
      this.schoolDescriptionPdfUrlPath = null;
    }
    if (this.registrationDescriptionInputMethod === 'FileUpload') {
      if (!this.registrationDescriptionPdfUrlPath) {
        this.registrationDescriptionPdfUrlPath = null;
      }
    } else {
      this.registrationDescriptionPdfUrlPath = null;
    }

    return isValid;
  }
  //#endregion
  //#region location information panel operation
  initializeFormControl() {
    this.locationInfoForm = this.formBuilder.group({
      trainingName: [''],
      trainingDescription: [''],
      locationFormValue: this.formBuilder.array([])
    })
    

  }
  createLocationControls() {
    return this.formBuilder.group({
      locationName: new FormControl(''),
      locationDescription: new FormControl(),
      startDate: new FormControl(),
      endDate: new FormControl(),
      price: new FormControl(0),
      totalSeats: new FormControl(0),
      place: new FormControl(),
      remainingSeats: new FormControl({ value: 0, disabled: true })
    })
  }
  addNewLocation() {
    this.locationFormValue = this.locationInfoForm.get('locationFormValue') as FormArray;
    this.locationFormValue.push(this.createLocationControls());
  }
  deleteMechanicsLocation(i: number) {
    let body = {
      locationId: this.locationFormValue.value[i].locationId
    };
    this.adminService.deleteMechanicsLocation(body).subscribe(response => {
      if (response) {
        this.locationFormValue.removeAt(i);
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Deleted successfully!');
      }
    })

  }
  //#endregion

  //#region field reset
  resetForm(type) {
    if (type == 'reset') {
      this.schoolDescription = "";     
    } 
    if (type == 'cancel') {
      this.schoolDescription = "";
      this.selectedLanguage = "";
      this.mechanicsSchoolId = "";
      this.addNewLocation();
    }
    this.locationInfoForm.reset();
    this.registrationDescription = "";
    (this.locationInfoForm.get('locationFormValue') as FormArray).clear();
    //this.addNewLocation();
    this.mechanicsSchool.isLanguageCodeEmpty = false;
    this.mechanicsSchool.isLocationInfoPanelValid = false;
    this.mechanicsSchool.isRegistrtionPanelValid = false;
    this.mechanicsSchool.isEmptySchoolDescription = false;
    this.mechanicsSchool.isEmptyTrainingName = false;
    this.mechanicsSchool.isEmptyTrainingDescription = false;
    this.mechanicsSchool.isEmptyRegistrationDescription = false;
    this.mechanicsSchool.isGeneralInfoContinue = false;
    this.mechanicsSchool.isLocationInfoContinue = false;
    this.mechanicsSchool.isSubmitted = false;
    this.mechanicsSchool.isEmptySchoolDescriptionUrlPath = false;
    this.mechanicsSchool.isEmptyRegistrationDescriptionUrlPath = false;
    
  }
  //#endregion

  //#region save operations

  save() {
    if (!this.validateMechanicsSchoolPage()) { //validates all the panel 
      return;
    }
    this.activatePanel(-1);//collapse all panel;
    const controls = this.locationInfoForm.controls;
  
    const body: IMechanicSchoolAdminBody = {
      id: 0,
      mechanicsSchoolId: this.mechanicsSchoolId,
      schoolDescription: this.schoolDescription,
      languageCode: this.selectedLanguage,
      trainingName: controls.trainingName.value,
      trainingDescription: controls.trainingDescription.value,
      registrationDescription: this.registrationDescription,
      mechanicsSchoolLocationDetails: this.locationFormValue.value,
      schoolDescriptionPdfUrlPath: this.schoolDescriptionPdfUrlPath,
      registrationDescriptionPdfUrlPath: this.registrationDescriptionPdfUrlPath
    }
    this.adminService.saveMechanicsSchoolDetails(body).subscribe(response => {
      //this.resetForm();
      if (response) {
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');
        this.lanaguageChange("");
      } else {
        this.appNotifyService.notify(NotifyType.ERROR, 'Something went wrong!');
      }
    })
  }

  //viewPdf(url) {
  //  if (url) {
  //    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  //  } else {
  //    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://localhost:44356/ResourceCenter/Content/97911/ADME016EN.pdf");

  //  }

  //}

  //#endregion
  //#region panel change
  continueToNextPanel(activeTab) {
    if (activeTab == 'general information') {
      this.mechanicsSchool.isGeneralInfoContinue = true;
      if (!this.validateGenralInfoForm()) {
        this.mechanicsSchool.isGeneralInfoPanelValid = false;
        return;
      }
      this.mechanicsSchool.isGeneralInfoPanelValid = true;
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[1].expanded = true;
      this.panel.childrenItems[1].selected = true;
    }
    else if (activeTab == 'location') {
      this.mechanicsSchool.isLocationInfoContinue = true;
      if (!this.validateLocationInfoForm()) {
        this.mechanicsSchool.isLocationInfoPanelValid = false;
        return;
      }
      this.mechanicsSchool.isLocationInfoPanelValid = true;
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[2].expanded = true;
      this.panel.childrenItems[2].selected = true;
    }
  }
  public activatePanel(index: number) {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    if (index !== -1) {
      this.panel.childrenItems[index].expanded = true;
      this.panel.childrenItems[index].selected = true;
    }
  }
  //#endregion
  //#region Description Selected Upload

  schoolDescriptionSelected(event) {
    console.log(event);
  }
  schoolDescriptionUploadSuccess(event) {
    console.log(event);
    this.schoolDescriptionPdfUrlPath = event.response.body.paths[0];
    if (this.schoolDescriptionPdfUrlPath) {
     const url = environment.imageUrl +`/api/${this.schoolDescriptionPdfUrlPath}` ;
      this.schoolDescriptionPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("\\","/"));
      this.schoolDescriptionInputMethod = "FileUpload";
    } else {
      this.schoolDescriptionInputMethod = "TextEditor";
    }
  }
  fileRestrictions:FileRestrictions = {
    allowedExtensions: [".pdf"],
  };
  registrationDescriptionSelected(event) {
    console.log(event);
  }
  registrationDescriptionUploadSuccess(event) {
    console.log(event);
    this.registrationDescriptionPdfUrlPath = event.response.body.paths[0];
    this.registrationDescriptionPdfUrl = null;
    if (this.registrationDescriptionPdfUrlPath) {
      const url = environment.imageUrl + `/api/${this.registrationDescriptionPdfUrlPath}`;
      this.registrationDescriptionPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("\\", "/"));
      this.registrationDescriptionInputMethod = "FileUpload";
    } else {
      this.registrationDescriptionInputMethod = "TextEditor";
    }

  }
    //#endregion
}
